export default __webpack_public_path__ + "static/media/Shades-of-cotton-yarn-spun-and-dyed-in-Britain.dca41c0e.jpg";